import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const services = [
  {
    title: 'Carga suelta y paletizada',
    description: 'Traslado seguro de mercadería suelta y paletizada a todo el Perú.',
    icon: (
      <svg className="w-10 h-10 text-primary-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 7l9-4 9 4M4 10v10a1 1 0 001 1h14a1 1 0 001-1V10M4 10l8 4 8-4" /></svg>
    )
  },
  {
    title: 'Monitoreo 24/7',
    description: 'Seguimiento en tiempo real de tu carga durante todo el trayecto.',
    icon: (
      <svg className="w-10 h-10 text-primary-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6 6 0 10-12 0v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" /></svg>
    )
  },
  {
    title: 'Seguro de carga',
    description: 'Protección total de tu mercadería con seguro especializado.',
    icon: (
      <svg className="w-10 h-10 text-primary-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
    )
  },
  {
    title: 'Cobertura nacional',
    description: 'Llegamos a los destinos más recónditos del país.',
    icon: (
      <svg className="w-10 h-10 text-primary-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 12.414a4 4 0 10-5.657 5.657l4.243 4.243a8 8 0 1011.314-11.314l-4.243 4.243a4 4 0 00-5.657 5.657z" /></svg>
    )
  },
  {
    title: 'Flota moderna',
    description: 'Vehículos propios, modernos y en óptimas condiciones.',
    icon: (
      <svg className="w-10 h-10 text-primary-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 13l2-2m0 0l7-7 7 7M5 11v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0h6" /></svg>
    )
  },
  {
    title: 'Atención personalizada',
    description: 'Soporte y asesoría en cada etapa del servicio.',
    icon: (
      <svg className="w-10 h-10 text-primary-600 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5.121 17.804A13.937 13.937 0 0112 15c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
    )
  }
];

const steps = [
  { title: 'Cotiza tu envío', icon: '1' },
  { title: 'Recojo y traslado', icon: '2' },
  { title: 'Monitoreo en ruta', icon: '3' },
  { title: 'Entrega segura', icon: '4' },
];

const benefits = [
  'Rapidez y puntualidad garantizada',
  'Seguridad y monitoreo constante',
  'Cobertura nacional',
  'Atención personalizada',
  'Precios competitivos',
  'Experiencia comprobada en el sector',
];

const Services: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Servicios de Transporte | Royal Trucking</title>
        <meta name="description" content="Conoce los servicios de transporte de carga, logística y distribución de Royal Trucking en todo el Perú. Flota moderna y atención personalizada." />
      </Helmet>
      <div className="min-h-screen bg-gray-50">
        {/* Header */}
        <section className="relative bg-gradient-to-r from-primary-900 to-primary-700 text-white py-24" data-aos="fade-up">
          <div className="absolute inset-0 bg-black opacity-30"></div>
          <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h1 className="text-4xl lg:text-5xl font-bold mb-4">Nuestros Servicios</h1>
            <p className="text-xl text-primary-100 max-w-2xl mx-auto mb-6">
              Soluciones integrales de transporte de carga por carretera, con cobertura nacional y atención personalizada.
            </p>
            <Link to="/contact" className="inline-block bg-accent-200 text-primary-900 font-bold px-8 py-3 rounded-lg shadow-lg hover:bg-accent-100 transition-colors mt-2">
              Solicita tu cotización
            </Link>
          </div>
        </section>

        {/* Servicios Destacados */}
        <section className="py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
              {services.map((srv, i) => (
                <div key={srv.title} className="bg-white rounded-2xl shadow-xl p-8 text-center hover:shadow-2xl transition-shadow duration-300" data-aos="fade-up" data-aos-delay={i * 80}>
                  {srv.icon}
                  <h3 className="text-xl font-bold mb-2 text-gray-900">{srv.title}</h3>
                  <p className="text-gray-600 mb-2">{srv.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Proceso de Servicio */}
        <section className="py-16 bg-logo-gray-100">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-gray-900 text-center mb-10">¿Cómo funciona nuestro servicio?</h2>
            <div className="flex flex-col md:flex-row justify-center items-center gap-8">
              {steps.map((step, i) => (
                <div key={step.title} className="bg-white rounded-xl shadow-lg p-6 flex flex-col items-center w-56" data-aos="zoom-in" data-aos-delay={i * 100}>
                  <div className="w-12 h-12 bg-primary-200 rounded-full flex items-center justify-center text-2xl font-bold text-primary-700 mb-3">{step.icon}</div>
                  <div className="text-lg font-semibold text-gray-900 text-center">{step.title}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Beneficios */}
        <section className="py-16">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-2xl font-bold text-gray-900 text-center mb-10">Beneficios para tu empresa</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              {benefits.map((b, i) => (
                <div key={b} className="flex items-center gap-4" data-aos="fade-right" data-aos-delay={i * 60}>
                  <svg className="w-7 h-7 text-accent-200 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
                  <span className="text-gray-700 text-lg">{b}</span>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA Final */}
        <section className="py-20 bg-primary-600 text-white text-center" data-aos="fade-up">
          <div className="max-w-3xl mx-auto px-4">
            <h2 className="text-3xl font-bold mb-4">¿Listo para transportar tu carga con Royal Trucking?</h2>
            <p className="text-xl mb-8 text-primary-100">Contáctanos y recibe una atención personalizada y una cotización a medida para tu empresa.</p>
            <Link to="/contact" className="inline-block bg-accent-200 text-primary-900 font-bold px-10 py-4 rounded-lg shadow-lg hover:bg-accent-100 transition-colors">
              Solicitar Cotización
            </Link>
          </div>
        </section>
      </div>
    </>
  );
};

export default Services; 